import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, TextField } from '@mui/material';
import { getSearchListCategories } from '../../services/content.service';
import { getLocalValue } from '../../utils/local-cache.util';
import {
  LS_ADMIN_USER_ID,
  LS_ADMIN_USER_ROLE,
  ADMIN_USER_ROLE,
} from '../../config/const.config';

const SearchableCategory = ({
  id,
  name,
  label,
  defaultValue,
  multiple,
  disabled,
  onChange,
  sx,
  error,
  refetchData,
}) => {
  const selectedValue = defaultValue || (multiple ? [] : null);

  const [options, setOptions] = useState([]);
  const [value, setValue] = useState(selectedValue);
  const [inputValue, setInputValue] = useState('');
  const [adminUserRole] = useState(getLocalValue(LS_ADMIN_USER_ROLE));

  useEffect(() => {
    // for feature and playlist category assignment
    const adminUserId = getLocalValue(LS_ADMIN_USER_ID);

    getSearchListCategories(adminUserId)
      .then((res) => {
        setOptions(res?.data || []);
        setValue(defaultValue);
      })
      .catch(() => {
        // upon error, show loading only
      });
  }, [defaultValue, refetchData]);

  return (
    <Autocomplete
      id={id}
      name={name}
      options={options}
      getOptionLabel={(option) =>
        `${option.title} ${
          adminUserRole === ADMIN_USER_ROLE.ADMIN && option.channelName
            ? ` (${option.channelName})`
            : ''
        }`
      }
      sx={sx}
      value={value}
      onChange={(e, v) => {
        setValue(v);
        onChange(v);
      }}
      inputValue={inputValue}
      onInputChange={(e, v) => {
        setInputValue(v);
      }}
      multiple={multiple}
      disabled={disabled}
      // loading={loading}
      isOptionEqualToValue={(op, vl) => op.id === vl.id}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={error !== ''}
          helperText={error}
          variant="filled"
        />
      )}
      renderOption={(props, option) => (
        <li
          {...props}
          style={{ color: option.status === 0 ? 'grey' : 'inherit' }}
        >
          {option.title}{' '}
          {adminUserRole === ADMIN_USER_ROLE.ADMIN && option.channelName
            ? ` (${option.channelName})`
            : ''}
        </li>
      )}
    />
  );
};

SearchableCategory.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  loadOption: PropTypes.func.isRequired,
  defaultValue: PropTypes.any,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.shape(),
  error: PropTypes.string,
  dataId: PropTypes.number,
  refetchData: PropTypes.bool,
};
SearchableCategory.defaultProps = {
  multiple: false,
  disabled: false,
  sx: {},
  defaultValue: null,
  error: '',
  dataId: null,
  refetchData: false,
};

export default SearchableCategory;
